import Footer from './footer.vue'
export default Footer